import { Component, OnInit } from '@angular/core';
import { BankClosingService, BankClosingResponseDTO } from '../../../services/bank-closing.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-closed-periods-list',
  templateUrl: './closed-periods-list.component.html',
  styleUrls: ['./closed-periods-list.component.scss']
})
export class ClosedPeriodsListComponent implements OnInit {
  closedPeriods: BankClosingResponseDTO[] = [];
  filteredPeriods: BankClosingResponseDTO[] = [];
  loading = false;

  // Filters
  banks: any[] = [];
  selectedBankId: number | null = null;
  selectedYear: number | null = null;
  availableYears: number[] = [];

  // Detail modal
  showDetailModal = false;
  selectedPeriod: BankClosingResponseDTO | null = null;

  constructor(
    private bankClosingService: BankClosingService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.loadBanks();
    this.loadClosedPeriods();
    this.generateYearOptions();
  }

  loadBanks(): void {
    this.http.get<any>(`${environment.apiUrl}/Banks`).subscribe({
      next: (result: any) => {
        if (result.isSuccess && result.data) {
          this.banks = result.data;
        }
      },
      error: (err: any) => console.error('Error loading banks:', err)
    });
  }

  loadClosedPeriods(): void {
    this.loading = true;
    this.bankClosingService.getClosedPeriods(this.selectedBankId || undefined, this.selectedYear || undefined)
      .subscribe({
        next: (result) => {
          this.loading = false;
          if (result.isSuccess && result.data) {
            this.closedPeriods = result.data;
            this.filteredPeriods = [...this.closedPeriods];
          }
        },
        error: (err) => {
          this.loading = false;
          console.error('Error loading closed periods:', err);
        }
      });
  }

  generateYearOptions(): void {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= currentYear - 5; i--) {
      this.availableYears.push(i);
    }
  }

  applyFilters(): void {
    this.loadClosedPeriods();
  }

  clearFilters(): void {
    this.selectedBankId = null;
    this.selectedYear = null;
    this.loadClosedPeriods();
  }

  viewDetail(period: BankClosingResponseDTO): void {
    // Load full summary from backend
    this.loading = true;
    this.bankClosingService.getClosureSummary(period.bankId, period.year, period.month).subscribe({
      next: (result: any) => {
        this.loading = false;
        if (result.isSuccess && result.data) {
          this.selectedPeriod = result.data;
          this.showDetailModal = true;
        }
      },
      error: (err: any) => {
        this.loading = false;
        console.error('Error loading closure summary:', err);
        // Fallback to period data from list
        this.selectedPeriod = period;
        this.showDetailModal = true;
      }
    });
  }

  closeDetailModal(): void {
    this.showDetailModal = false;
    this.selectedPeriod = null;
  }

  getMonthName(month: number): string {
    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    return months[month - 1] || '';
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }
}
